module.exports = __webpack_public_path__ + "img/pck_iz_zraka_3.6021bb4b.jpg";